import { render, staticRenderFns } from "./CustomAttributeSelector.vue?vue&type=template&id=933948f2&scoped=true&"
import script from "./CustomAttributeSelector.vue?vue&type=script&lang=js&"
export * from "./CustomAttributeSelector.vue?vue&type=script&lang=js&"
import style0 from "./CustomAttributeSelector.vue?vue&type=style&index=0&id=933948f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "933948f2",
  null
  
)

export default component.exports